<template>
  <b-overlay
    :show="showOverlay"
    opacity="0.5"
    :variant="$store.state.appConfig.layout.skin"
    rounded="sm"
  >
    <div>
      <template v-for="(existAttachment, index) in existsAttachments">
        <b-row
          :key="index"
          class="mb-5"
        >
          <b-col cols="8">
            <a
              :href="existAttachment.url"
              target="_blank"
            >{{ existAttachment.name }}</a>
          </b-col>
          <b-col cols="4">
            <b-button
              variant="outline-danger"
              @click="deleteAttachment(existAttachment, index)"
            >
              {{ $t("Delete attachment") }}
            </b-button>
          </b-col>
        </b-row>
      </template>
      <b-form-group
        label-class="text-secondary font-weight-bolder"
        :label="$t('File')"
        label-for="attachments"
      >
        <b-row
          v-for="(attachmentFile, index) in form.attachments"
          :key="index"
          class="mb-5"
        >
          <b-col
            cols="8"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('File')"
              :rules="rules"
            >
              <b-form-file
                v-model="attachmentFile.file"
                class="direction-rtl"
                :browse-text="$t('Select file')"
                :placeholder="$t('Select one file')"
                :state="errors.length > 0 ? false : null"
              />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </b-col>
          <b-col
            cols="4"
          >
            <b-button
              v-if="
                index === 0 &&
                  (attachmentFile.progress === undefined || attachmentFile.progress === 0)
              "
              variant="outline-primary"
              size="md"
              @click="addFile"
            >
              {{ $t("New file") }}
            </b-button>
            <b-button
              v-else-if="
                attachmentFile.progress === undefined || attachmentFile.progress === 0
              "
              size="md"
              variant="outline-danger"
              @click="deleteFile(index)"
            >
              {{ $t("Delete file") }}
            </b-button>
            <b-progress
              v-else
              class="mt-4"
              :value="attachmentFile.progress"
              :precision="2"
              max="100"
              show-value
            />
          </b-col>
        </b-row>
      </b-form-group>
    </div>
  </b-overlay>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormFile,
  BButton,
  BProgress,
  BOverlay,
} from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'

import { attachment, fileSize } from '@validations'

export default {
  name: 'AttachmentsForm',
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormFile,
    BButton,
    BProgress,
    BOverlay,
    ValidationProvider,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    existsAttachments: {
      type: Array,
      default: () => [],
    },
    rules: {
      type: String,
      default: () => 'attachment:image/png,image/jpeg,image/jpg,video/mp4,application/pdf,application/msword, application/vnd.ms-excel|file-size:20',
    },
  },
  data() {
    return {
      showOverlay: false,
      attachment,
      fileSize,
    }
  },
  methods: {
    addFile() {
      if (this.form.attachments.length < 3) {
        this.form.attachments.push({
          file: null,
          progress: 0,
        })
      }
    },
    deleteFile(index) {
      this.form.attachments.splice(index, 1)
    },
    deleteAttachment(existAttachment, index) {
      this.showConfirmDialog().then(() => {
        this.showOverlay = true
        this.$http.delete(`attachments/${existAttachment.id}`).then(({ message }) => {
          this.showOverlay = false
          this.showSuccessNotification(message || this.$t('The deletion was successful'))
          this.existsAttachments.splice(index, 1)
          this.showOverlay = false
        }).catch(() => {
          this.showOverlay = false
        })
      })
    },
  },
}
</script>

<style scoped></style>
